module.exports = __webpack_public_path__ + "static/media/send.fe4f1a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/DTMF/send.svg
// module id = 1765
// module chunks = 0